module.exports = __webpack_public_path__ + "img/title_bg2.1d3fa673.png";